import React, { useState } from 'react';
import classNames from 'classnames';
import withLgpdCookie from 'govbr.lgpd.plugin/components/withLgpdCookie';
import { defineMessages, useIntl } from 'react-intl';
import Slider from 'react-slick';

import { useBannerServices } from '../../hooks/useBannerServices';

import styles from './BannerServicos.module.less';
import ServiceList from './components/ServiceList/ServiceList';

const cx = classNames;

const messages = defineMessages({
  mostAccessedServices: {
    id: 'MostAccessedServices',
    defaultMessage: 'Most Accessed Services from Gov.br',
  },
  recommendedServices: {
    id: 'RecommendedServicesForYou',
    defaultMessage: 'Recommended Services for You',
  },
  featuredServices: {
    id: 'FeaturedServices',
    defaultMessage: 'Featured Services from Gov.br',
  },
  empty: {
    id: 'NoServicesFound',
    defaultMessage: 'No Services Found',
  },
  recommendedEmptyTitle: {
    id: 'NoRecommendedServicesAvailable',
    defaultMessage: 'No Recommended Services Available',
  },
  recommendedEmptyMessage: {
    id: 'NoBrowsingHistory',
    defaultMessage:
      'It seems that you have not visited any Gov.br services yet.',
  },
  errorMessage: {
    id: 'ErrorMessage',
    defaultMessage: 'Unable to load at the moment. Please try again later.',
  },
  errorTitle: {
    id: 'ErrorTitle',
    defaultMessage: 'Something went wrong.',
  },
});

const BannerServicos = ({ performanceCookies }) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const {
    loading,
    govHomeServicesError,
    recommendationsError,
    loaded,
    servicosDestaque,
    servicosMaisAcessados,
    recommendations,
    loadData,
  } = useBannerServices();

  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    initialSlide: 0,
    centerMode: true,
    centerPadding: '20px',
    slidesToScroll: 1,
    slidesToShow: 1,
    beforeChange: (_old, next) => setCurrentSlide(next),
  };

  const handleOpen = () => {
    if (!loaded && !loading) {
      loadData();
    }

    setOpen((prev) => !prev);
  };

  const listProps = {
    open,
    loading,
    setOpen: handleOpen,
  };

  const rawContent = [
    performanceCookies && {
      key: 'recommended',
      component: (
        <ServiceList
          {...listProps}
          listName="recommended"
          error={recommendationsError}
          errorTitle={intl.formatMessage(messages.errorTitle)}
          errorMessage={intl.formatMessage(messages.errorMessage)}
          emptyMessage={intl.formatMessage(messages.recommendedEmptyMessage)}
          emptyTitle={intl.formatMessage(messages.recommendedEmptyTitle)}
          title={intl.formatMessage(messages.recommendedServices)}
          items={recommendations}
          icon="fa-solid fa-hand-point-right"
          iconColor="#00A91C"
          showIcon
        />
      ),
    },
    {
      key: 'mostAccessed',
      component: (
        <ServiceList
          {...listProps}
          listName="mostAccessed"
          error={govHomeServicesError}
          errorTitle={intl.formatMessage(messages.errorTitle)}
          errorMessage={intl.formatMessage(messages.errorMessage)}
          emptyMessage={intl.formatMessage(messages.empty)}
          emptyTitle={intl.formatMessage(messages.mostAccessedServices)}
          title={intl.formatMessage(messages.mostAccessedServices)}
          items={servicosMaisAcessados}
          icon="fa-solid fa-fire-flame-curved"
          iconColor="#EF5E25"
          showRanking
        />
      ),
    },
    {
      key: 'featured',
      component: (
        <ServiceList
          {...listProps}
          listName="featured"
          error={govHomeServicesError}
          errorTitle={intl.formatMessage(messages.errorTitle)}
          errorMessage={intl.formatMessage(messages.errorMessage)}
          emptyMessage={intl.formatMessage(messages.empty)}
          emptyTitle={intl.formatMessage(messages.featuredServices)}
          title={intl.formatMessage(messages.featuredServices)}
          items={servicosDestaque}
          icon="fa-solid fa-star"
          iconColor="#FFBE2E"
          showCategory
        />
      ),
    },
  ].filter(Boolean);

  // Desktop: todos ativos (sem restrição de foco)
  const contentDesktop = rawContent.map((e) =>
    React.cloneElement(e.component, { key: e.key }),
  );

  // Mobile (slider): somente slide atual focável
  const contentMobile = rawContent.map((entry, index) =>
    React.cloneElement(entry.component, {
      key: entry.key,
      isActive: index === currentSlide,
      tabIndexOverride: index === currentSlide ? 0 : -1,
    }),
  );

  return (
    <div className={cx('banner-servicos', styles.root)}>
      <div className="ui container">
        <div className={styles.desk}>{contentDesktop}</div>
      </div>
      <div className={styles.mobile}>
        <Slider {...settings}>{contentMobile}</Slider>
      </div>
    </div>
  );
};

export default withLgpdCookie(BannerServicos);
